import { useState, useEffect } from "react";
import styles from "./Hero.module.css";
import axios from "axios";

import Button from "../ui/Button/Button";

const Hero = () => {
  const [movie, setMovie] = useState(null);
  const API_KEY = process.env.REACT_APP_API_KEY;

  const genres = movie?.genres?.map((genre) => genre.name).join(", ");
  const trailer = movie?.videos?.results?.[0]?.key
    ? `https://www.youtube.com/watch?v=${movie.videos.results[0].key}`
    : "#";

  function getRandomInt(max) {
    return Math.floor(Math.random() * max);
  }

  async function getTrendingMovie() {
    const URL = `https://api.themoviedb.org/3/trending/movie/day?api_key=${API_KEY}`;
    const response = await axios(URL);
    return response.data.results[getRandomInt(20)];
  }

  async function getDetailMovie() {
    const trendingMovie = await getTrendingMovie();
    const id = trendingMovie.id;

    const URL = `https://api.themoviedb.org/3/movie/${id}?api_key=${API_KEY}&append_to_response=videos`;
    const response = await axios(URL);
    setMovie(response.data);
  }

  useEffect(() => {
    getDetailMovie();
  }, []);

  if (!movie) return <p>Loading...</p>;

  return (
    <div className={styles.container}>
      <section className={styles.hero}>
        <div className={styles.hero__left}>
          <h2 className={styles.hero__title}>{movie.title}</h2>
          <h3 className={styles.hero__genre}>{genres}</h3>
          <p className={styles.hero__description}>{movie.overview}</p>
          <Button as="a" href={trailer} target="_blank" size="md" variant="secondary">
            Watch
          </Button>
        </div>
        <div className="hero__right">
          <img
            className={styles.hero__image}
            src={`https://image.tmdb.org/t/p/w500/${movie.backdrop_path}`}
            alt={movie.title}
          />
        </div>
      </section>
    </div>
  );
};

export default Hero;